import Spacer from '@components/Spacer/Spacer';
import * as styles from '@layouts/HomeLayout.module.scss';
import * as React from 'react';
export default {
  Spacer,
  styles,
  React
};